﻿import {CardItemLabel} from "../CardItemLabel";
import {withUppercase} from "../../../../hocs/withUppercase";

export const CardItemLabelWithUppercase = withUppercase(CardItemLabel);
